module.exports = __webpack_public_path__ + "img/proList2_27.2aae681a.jpg";